import React from 'react';
import ScrollingSection from '../../../../../components/scrolling-section';
import { useGetChallengeRowsQuery } from '../../../../../client/query/challenges';

export const DEFAULT_ROUTE = '/challenges';

interface IProps {
  title: string;
  href: string;
  index?: number;
}

const ChallengesRow: React.FC<IProps> = ({ title, href, index }) => {
  const route = href || DEFAULT_ROUTE;

  const { data, isError, isFetching, refetch } = useGetChallengeRowsQuery();

  return (
    <ScrollingSection
      reload={refetch}
      key={'challengesSection'}
      isLoading={isFetching}
      title={data?.data?.[0]?.title || title}
      listData={data}
      route={route}
      isError={isError}
      analytics={{
        engagementData: {
          rowNumber: index,
        },
      }}
    />
  );
};

export default ChallengesRow;
